import { parseTime } from "./time"

export class TaskScheduler {
  constructor({ start, end, interval, onTick, onPendingTick, onStateChange }) {
    this.startTime = parseTime(start)
    this.endTime = parseTime(end)
    this.interval = interval
    this.onTick = onTick
    this.onPendingTick = onPendingTick
    this.onStateChange = onStateChange
  }

  schedule() {
    const now = new Date()
    this.stop()

    if (this.endTime && now > this.endTime)
      return this.onStateChange?.("expired")

    if (!this.startTime || now >= this.startTime) return this.#run()

    this.onStateChange?.("pending")
    this.#startTimer(this.interval, this.onPendingTick)
    this.waiter = setTimeout(() => this.#run(), this.startTime - now)
  }

  stop() {
    clearTimeout(this.waiter)
    clearInterval(this.timer)
  }

  #run() {
    this.stop()
    this.onStateChange?.("running")
    this.#startTimer(this.interval, this.onTick)
  }

  #startTimer(ms, callback) {
    const tick = () => {
      if (this.endTime && new Date() > this.endTime) {
        this.stop()
        return this.onStateChange?.("expired")
      }
      callback?.()
    }

    tick()
    if (ms > 0) this.timer = setInterval(tick, ms)
  }
}
